export default __webpack_public_path__ + "static/media/futurr.cc0fc3ee.PNG";